// /forms/user/initialState.js
export const initialFormData = {};

export const initialFlightSets = [
  {
    airportFrom: "",
    airportTo: "",
    airline: "",
    flightNumber: "",
    departureDate: "",
    departureTime: "",
    arrivalDate: "",
    arrivalTime: "",
  },
];
